export const Tangible = {
  currentTangible: 6002,
  expiredTangible: 6006,
};
